import React, {Component} from "react";
import {Fragment} from "react";
import {payment_methods, statuses} from "./constants";
import RefundOption from "./RefundOption";

class SwitchStatuses extends Component{
    render(){
        const {pastReservation, translate, changePopUpStatus, rescheduleReservation} = this.props;
        return switchStatuses(pastReservation.status, pastReservation, changePopUpStatus, rescheduleReservation, translate);
    }
}





const missed = (pastReservation, changePopUpStatus, rescheduleReservation, translate) => {
    return (
        <Fragment>
            <hr/>
            <div className="row past-res-details">
                <div className="options cursor-pointer"
                     onClick={(e) => changePopUpStatus(e, "open", "add-report-overlay", pastReservation)}>
                    <p className="upper text-center"><i className="fas fa-info fa-fw"></i></p>
                    <h6 className="capitalized">{translate("report")}</h6>
                </div>
                <div className="right-hr"></div>
                <div className="options cursor-pointer"
                     onClick={rescheduleReservation}>
                    <p className="upper text-center"><i
                        className="fas fa-sync-alt fa-fw"></i></p>
                    <h6 className="capitalized">{translate("reschedule")}</h6>
                </div>


                <RefundOption  pastReservation={pastReservation} changePopUpStatus={changePopUpStatus} translate={translate} />

            </div>
        </Fragment>
    )
};

const cancel = (pastReservation, changePopUpStatus, translate) => {
    return (
        <Fragment>
            {
                pastReservation.payment_method === payment_methods.CREDIT_CARD
                ||  pastReservation.payment_method === payment_methods.INSTALLMENT ?
                    <Fragment>
                        <hr/>
                        <div className="row past-res-details">


                            <div className="options cursor-pointer"
                                 onClick={(e) => changePopUpStatus(e, "open", "refund-overlay", pastReservation)}>
                                <p
                                    className="upper text-center cursor-pointer">
                                    <i className="fas fa-dollar-sign fa-fw"></i>
                                </p>
                                <h6 className="capitalized dark-blue">{translate("refund")}</h6>
                            </div>
                        </div>
                    </Fragment>
                    : null
            }
        </Fragment>
    )
};

const approved = (pastReservation, changePopUpStatus, translate) => {
    return (
        <Fragment>
            <hr/>
            <div className="row past-res-details">
                <div className="options cursor-pointer"
                     onClick={(e) => changePopUpStatus(e, "open", "add-report-overlay", pastReservation)}>
                    <p className="upper text-center"><i className="fas fa-info fa-fw"></i></p>
                    <h6 className="capitalized">{translate("report")}</h6>
                </div>
                {pastReservation.has_review !== 1 ?
                    <Fragment>
                        <div className="right-hr"></div>
                        <div className="options"
                             onClick={(e) => changePopUpStatus(e, "open", "review-overlay", pastReservation)}>
                            <p className="upper text-center cursor-pointer">
                                <i className="far fa-star fa-fw"></i>
                            </p>
                            <h6 className="capitalized">{translate("review")}</h6>
                        </div>
                    </Fragment>
                    : null}
            </div>
        </Fragment>
    )
};

const switchStatuses = (status, pastReservation, changePopUpStatus, rescheduleReservation, translate) =>  {
    switch (status) {
        case statuses.MISSED:
            return missed(pastReservation, changePopUpStatus, rescheduleReservation, translate);
        case statuses.CANCELED:
            return cancel(pastReservation, changePopUpStatus, translate);
        case statuses.APPROVED:
            return approved(pastReservation, changePopUpStatus, translate);
        default:
            //

    }
};

export default SwitchStatuses;